import { Box, useTheme } from '@mui/material';
import { UruannaMark } from '@/components/brand/UruannaMark';

const BRAND = `${import.meta.env.BASE_URL}brand/`;

/** Owner-supplied artwork, used as given (`public/brand`). Width ÷ height. */
const ARTWORK = {
  /** Mark + URWANA, no tagline: the top bar and the sidebar. */
  wordmark: { file: 'uruanna-wordmark', ratio: 1370 / 420 },
  /** Mark + URWANA + PHARMACEUTICALS: the sign-in pane and print only. */
  lockup: { file: 'uruanna-lockup', ratio: 1370 / 420 },
} as const;

/**
 * The URWANA logo. `compact` is the double-burst mark alone (the collapsed
 * sidebar); otherwise the wordmark, or the full lockup where the brand has the
 * room. `brand` follows the mode — indigo artwork on light, the white artwork
 * on dark — and `inverse` is always the white artwork, for the indigo pane.
 */
export function Logo({
  compact,
  tone = 'brand',
  variant = 'wordmark',
  height,
}: {
  compact?: boolean;
  tone?: 'brand' | 'inverse';
  variant?: keyof typeof ARTWORK;
  /** Rendered height in px. */
  height?: number;
}) {
  const theme = useTheme();
  if (compact) return <UruannaMark size={height ?? 28} tone={tone} />;

  const white = tone === 'inverse' || theme.palette.mode === 'dark';
  const art = ARTWORK[variant];
  const h = height ?? (variant === 'lockup' ? 76 : 34);
  return (
    <Box
      component="img"
      src={`${BRAND}${art.file}${white ? '-white' : ''}.svg`}
      alt="URWANA"
      width={Math.round(h * art.ratio)}
      height={h}
      sx={{ display: 'block', flexShrink: 0, maxWidth: '100%', height: 'auto' }}
    />
  );
}
